import mitt, { Emitter } from './utils/event'

let emitter: Emitter<any> = mitt()

export function initEmitter() {
  emitter = mitt()
}

export default emitter
